<template>
	<div id="publishers-advantages" class="advantages">
		<div class="advantages__wrapper">
			<div class="advantages__container container">
				<h2 class="advantages__title heading h2">
					<span class="advantages__title-line">
						{{ $t('pages.publishers.sections.advantages.titleLine1') }}
					</span>
					<span class="advantages__title-line">
						{{ $t('pages.publishers.sections.advantages.titleLine2') }}
					</span>
				</h2>
				<div class="advantages__content">
					<BlocksPublishersAdvantagesTimeline :data="advantages" />
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
	const { tm } = useI18n()
	const advantages = computed(
		() =>
			tm('pages.publishers.sections.advantages.accordion.items') as {
				icon: string
				title: string
				text: string
			}[]
	)
</script>
<style lang="scss" scoped>
	.advantages {
		position: relative;
		z-index: 1;
		color: var(--white);
		background-color: var(--black);
		&__wrapper {
			padding: 64px 0;
		}
		&__title {
			text-transform: uppercase;
			:deep(.advantages__title-line) {
				display: block !important;
				white-space: nowrap;
			}
		}
		&__content {
			margin-top: 64px;
		}
	}
</style>
